// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { HistoryType } from "../../../Utils/History/HistoryType.ts";
import { ChartDataType, ChartHistoryType } from "../../../Chart/Utils/ChartConstants.js";

// TODO. Refactor. UGLY.
export let HistoricalData = function (holder, customInstrument, customCashItem)
{
    this._holder = holder
    this.cashItem = customCashItem || holder.FParent
    this.Instrument = customInstrument || holder.MainChart.Instrument()

    // Taken from HistoricalData.cs Apply() method.
    this.GetCashItemCount =
        this.cashItem === holder.FParent
            ? this.BarsCountParent
            : this.BarsCountAny
}

Object.defineProperty(HistoricalData.prototype, 'Indicator',
    {
        get: function () { return this._holder }
    })

Object.defineProperty(HistoricalData.prototype, 'Count',
    {
        get: function ()
        {
            return this.GetCashItemCount(this.cashItem)
        }
    })

Object.defineProperty(HistoricalData.prototype, 'HistoryCount',
    {
        get: function () { return this.cashItem ? this.cashItem.Count() : 0 }
    })

Object.defineProperty(HistoricalData.prototype, 'Period',
    {
        get: function () { return this.cashItem.FPeriod }
    })

// TODO. Refactor. UGLY.
Object.defineProperty(HistoricalData.prototype, 'Account',
    {
        get: function () { return this._holder.MainChart.model.GetAccount() }
    })

Object.defineProperty(HistoricalData.prototype, 'DataType',
    {
        get: function () { return this.cashItem.HistoryType }
    })

// TODO. Refactor. UGLY.
Object.defineProperty(HistoricalData.prototype, 'UseDefaultInstrumentHistoryType',
    {
        get: function () 
        {
            return this._holder.MainChart.ChartHistoryType() ===
                ChartHistoryType.Default
        }
    })

// TODO. Refactor. UGLY.
Object.defineProperty(HistoricalData.prototype, 'FirstBarOpenTime',
    {
        get: function () 
        {
            let time = this.cashItem.GetOpenTime(0)
            return new Date(time || 0)
        }
    })

HistoricalData.prototype.Time = function (offset = 0)
{
    let count = this.GetCashItemCount(this.cashItem)
    if (!count)
        throw new Error('Cannot get the value from the empty data')

    let time = this.cashItem.GetOpenTime(count - 1 - offset)
    return new Date(time || 0)
}

HistoricalData.prototype.BarsCountParent = function (ci)
{
    return this._holder.FCount
}

HistoricalData.prototype.BarsCountAny = function (ci)
{
    return ci ? ci.Count() : 0
}

HistoricalData.prototype.GetPrice = function (par0, par1)
{
    if (par0 !== undefined && par1 !== undefined)
        return this.getPriceByTypeAndOffset(par0, par1)
    if (par0 !== undefined && par1 === undefined)
        return this.getPriceByType(par0)
}

HistoricalData.prototype.getPriceByType = function (priceType)
{
    let ci = this.cashItem
    let count = this.GetCashItemCount(ci)
    return ci.GetByType(
        count - 1,
        ci.Period !== 0 ? priceType : 2/*bid*/)
}

HistoricalData.prototype.getPriceByTypeAndOffset = function (priceType, offset)
{
    let ci = this.cashItem
    let count = this.GetCashItemCount(ci)
    if (offset < 0 || offset >= count)
        throw new Error('offset ' + offset + ' should be non-negative and smaller than Count')

    return ci.GetByType(
        count - 1 - offset,
        ci.Period !== 0 || ci.ChartDataType !== ChartDataType.Default ? priceType : 2/*bid*/)
}

HistoricalData.prototype.Volume = function (offset)
{
    offset = offset || 0
    let ci = this.cashItem
    let count = this.GetCashItemCount(ci)
    if (!count)
        throw new Error('Cannot get the value from the empty data')

    if (offset < 0 || offset >= count)
        throw new Error('offset ' + offset + ' should be non-negative and smaller than Count')

    return ci.GetVolume(count - 1 - offset)
}

HistoricalData.HistoricalDataFactory = function (holder, instrument, cashItem)
{
    // #65320 для агрегаций мы должны использовать BarData
    if (cashItem.Period === 0 && cashItem.ChartDataType === ChartDataType.Default)
    {
        if (cashItem.HistoryType === HistoryType.QUOTE_TRADES)
            return new TradeData(holder, instrument, cashItem)
        else
            return new TickData(holder, instrument, cashItem)
    }
    else
        return new BarData(holder, instrument, cashItem)
}

HistoricalData.prototype.FindInterval = function (par0, par1, par2)
{
    if (par0 !== undefined && par1 !== undefined && par2 !== undefined)
        return this.cashItem.FindInterval(par0, par1, par2)
    if (par0 !== undefined && par1 === undefined && par2 === undefined)
        return this.cashItem.FindIntervalByTime(par0)
}

// #region TradeData

export let TradeData = function (holder, instrument, cashItem)
{
    throw new Error('Not implemented')
}

TradeData.prototype = Object.create(HistoricalData.prototype)

// #endregion TradeData

// #region TickData

export let TickData = function (holder, instrument, cashItem)
{
    throw new Error('Not implemented')
}

TickData.prototype = Object.create(HistoricalData.prototype)

// #endregion TickData

// #region BarData

export let BarData = function (holder, instrument, cashItem)
{
    HistoricalData.call(this, holder, instrument, cashItem)
}

BarData.prototype = Object.create(HistoricalData.prototype)

// #endregion BarData